// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import promise from 'es6-promise'
promise.polyfill()
import Vue from 'vue'
import App from './App'
import router from './router'
import i18n from './lang'
import rum from './tool/rum'
import Tracker from './tool/ta'
import store from './store'
import axios from 'axios'
import toastPlugin from './tool/toast/toast'
import './registerServiceWorker'
import './assets/styles/index.less'
// 加载游戏特殊UI，实现游戏特殊UI的样式覆盖
import '@gameAssets/index.less'
import VueLazyload from 'vue-lazyload'
import { preloadBonusRewardPics } from '@/tool/preloadRewardPic'
Vue.use(VueLazyload)
// 礼包插件注册
if (!['home', 'home_ru'].includes(process.env.VUE_APP_GAME_NAME)) {
  if (process.env.VUE_APP_GAME_ID === '20195') {
    require('@/features/gift/plugins/fat')
  } else if (
    process.env.VUE_APP_GAME_ID === '20121' ||
    process.env.VUE_APP_GAME_ID === '20235' ||
    process.env.VUE_APP_GAME_ID === '20317' ||
    process.env.VUE_APP_GAME_ID === '20349' ||
    process.env.VUE_APP_GAME_ID === '20343'
  ) {
    require('@/features/gift/plugins/fuzhou')
  } else {
    require('@/features/gift/plugins/default-shop')
  }
}
// 弹屏活动注册（根据游戏配置条件加载，支持 tree-shaking）
const popupActivities = process.env.VUE_APP_POPUP_ACTIVITIES || ''
if (popupActivities.includes('bonus-reward')) {
  preloadBonusRewardPics()
  require('@/features/popup-activities/plugins/bonus-reward')
}
if (process.env.NODE_ENV !== 'production') {
  window.__TEST__ = true
  const originalDateNow = Date.now.bind(Date)
  Date.now = () => {
    const now = originalDateNow()
    const offset = Number(localStorage.getItem('webshop_local_time_offset') || 0)
    return now + offset * 1000
  }
}
import ENUM from './enum'
import installComponents from './tool/installComponents'
import utils from './tool/utils'
import filter from './filter'
import directive from './directive'
// 添加全局组件 $dialog方式
import { $dialog } from 'components'
Vue.use($dialog)
Vue.use(directive)

Vue.use(Tracker, {
  appId: process.env.VUE_APP_TGA_APPID,
  zoneOffset: parseInt(process.env.VUE_APP_TA_ZONE_OFFSET || 0),
})
Vue.use(rum, {})

Vue.use(toastPlugin)

Vue.use(installComponents)
Vue.prototype.$enum = ENUM
Vue.prototype.$utils = utils
Vue.use(filter)

axios.defaults.withCredentials = true
//axios.defaults.headers['x-requested-with'] = 'new'

Vue.config.errorHandler = function (err, vm, info) {
  console.error('err===', err)
  vm.$rum.errorReport(err, vm, info)
}

/* eslint-disable no-new */
let wshop = new Vue({
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>',
  data: {
    Bus: new Vue(),
  },
  render: (h) => h(App),
}).$mount('#app')

export default wshop
